<router-outlet></router-outlet>
@if (loading()) {
  <div class="position-fixed w-100 h-100 d-flex align-items-center justify-content-center top-0">
    <div class="position-absolute w-100 h-100 top-0 bg-body opacity-50"></div>
    <app-spinner></app-spinner>
  </div>
}
